var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.765 13.5219C2.43198 13.7301 2 13.4906 2 13.0979V4.90217C2 4.50945 2.43197 4.27003 2.765 4.47817L9.3216 8.57604C9.63494 8.77188 9.63494 9.22821 9.3216 9.42404L2.765 13.5219ZM17 10C16.4477 10 16 10.4478 16 11C16 11.5523 16.4477 12 17 12H29C29.5523 12 30 11.5523 30 11C30 10.4478 29.5523 10 29 10H17ZM2 19C2 18.4478 2.44772 18 3 18H29C29.5523 18 30 18.4478 30 19C30 19.5523 29.5523 20 29 20H3C2.44771 20 2 19.5523 2 19ZM3 26C2.44772 26 2 26.4478 2 27C2 27.5523 2.44771 28 3 28H29C29.5523 28 30 27.5523 30 27C30 26.4478 29.5523 26 29 26H3Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListEmpty);
export default __webpack_public_path__ + "static/media/list-empty.4f2f3ba5c1f17a70f8d50bef4f164739.svg";
export { ForwardRef as ReactComponent };